<template lang="pug">
v-card( class="columnReadOnly")  
    v-card-title {{ title  }}
    v-container(style="margin:10px!important;")  
        v-row 
            v-col      {{ category }}  - Numbero : {{ numberDocument }} 
        v-divider
        v-row    
            v-col
                card-title Valores Actuales
            v-col(style="background-color:white; color:black;") 
                card-title Valores Nuevos
        v-row(v-for="item in FormItems" class="columnReadOnly")     
            v-col                 
                v-text-field(style="color:white!important;" :label="item.FieldName" :value="item.ValueOld" outlined readonly hide-details="auto") 
                
            v-col(style="background-color:white;") 
                v-autocomplete( v-if="item.Type=='Select'" 
                                v-model="item.Value" 
                                :label="item.FieldName"  
                                :items="ItemsListSelectValue[item.ColumnName]"
                                item-text="Text"
                                item-value="IdDocListSelectValue" 
                                hide-details="auto"
                                @change="RealoadListSelectValue(item.IdDocListSelect,item.Value)"
                                outlined  ) 
                v-text-field( v-else-if="item.Type=='Date'"
                            v-model="item.Value"                             
                            outlined
                            :label="item.FieldName" hide-details="auto"                            type="date") 
                v-text-field(v-else v-model="item.Value" :label="item.FieldName" outlined hide-details="auto") 
        v-row 
            v-col 
            v-col(style="background-color:white; color:white")   
                v-btn(@click="UpdateData()" color="#5A6F87" block) ACTUALIZAR
    v-divider
    v-container   
        v-card-title Log
                v-spacer
                v-text-field(v-model="search" label="Busqueda...." class="mx-4" append-icon="mdi-magnify")        
                v-btn(color="success" @click="exportar('Log')") Exportar
                    i.fa.fa-plus-excel-o     
        v-data-table(      
                    :headers="tableHead"                 
                    :items="tableInfo"
                    :items-per-page="50"
                    heigth="300"
                    class="elevation-1 table1"
                    :search="search"   )
</template>
<script>  
import Vue from 'vue'
import apiWeb from "../../../../api/apiSLC.js"
import modelDocuType from "../../../../models/documentType.js"
import exportExcel from '../../../..//tools/exportExcel.js'
import { EventBus } from "../../../../complementos/event-bus.js";

export default { 
    props:{   
        idDocument:Number,  
        numberDocument:Number,
        category:String
    },  
    data(){
        return{  
            title:"",
            search:'',
            FormItems:[], 
            ItemsListSelectValue:{},
            ItemsListSelectValueOrigin:{},
            tableInfo:[],
            tableHead:[],
        }
    },

    mounted(){ 
        this.List_Info(this.idDocument)
        this.List_Info_Log(this.idDocument)
    },
    computed:{
        async ItemsList(id){
            return await this.GetListSelectValue(id)
        }
    },
    methods:{ 
        UpdateData(){
            for(let i=0; i<this.FormItems.length; i++){
                if(this.FormItems[i].Type=='Select'){
                    this.FormItems[i].Value= this.ItemsListSelectValue[this.FormItems[i].ColumnName].filter(b=> b.IdDocListSelectValue==this.FormItems[i].Value)[0].Text
                }
                this.FormItems[i].User=Vue.prototype.$info.idUser.toString()
                this.FormItems[i].IdDocument=this.idDocument
            }
            console.log(this.FormItems)
            apiWeb.post("Document/Document_Update",this.FormItems)
                .then(result=>{
                            if(result.status==0){
                                this.$emit("close")
                            }
                            else{
                                this.$msgbox.show(result.message,"Error nivel 1")
                            }
            })
            .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
            .finally(s=>{
                this.$emit("close")
            })
        },
        async GetListSelectValue(id,nameField){
            let formFilter={
                Text:'',
                Value:'',
                Active:2,
                IdEnterprise:1,
                IdDocListSelect:id,

            };
            await apiWeb.post("DocListSelect/DocListSelectValue_View",formFilter)
                        .then(result=>{
                                    if(result.status==0){
                                        this.ItemsListSelectValue[nameField]= JSON.parse(result.value) 
                                        this.ItemsListSelectValueOrigin[nameField]= JSON.parse(result.value) 
                                        let _result=this.FormItems.filter(b=> b.ColumnName==nameField)[0]
                                        
                                        this.FormItems.filter(b=> b.ColumnName==nameField)[0].Value=this.ItemsListSelectValueOrigin[nameField].filter(b=> b.Text==_result.ValueOld )[0].IdDocListSelectValue
                                    }
                                    else{
                                        this.$msgbox.show(result.message,"Error nivel 1")
                                    }
                        })
                        .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})

        },
       async List_Info(id){   
          
          await  apiWeb.get("Document/Document_Get",id)
                    .then(result=>{
                                if(result.status==0){
                                    this.FormItems=  JSON.parse((result.value))
                                      this.FormItems.forEach(row=>{
                                        
                                        if(row.Type=='Select'){
                                            this.GetListSelectValue(row.IdDocListSelect,row.ColumnName)
                                           
                                            //row.Value= this.ItemsListSelectValueOrigin[row.ColumnName].filter(b=> b.Text==row.ValueOld )[0].IdDocListSelectValue
                                        } 
                                    })

                                    }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        async List_Info_Log(id){               
            await  apiWeb.get("Document/Document_Get_Log",id)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableHead=[] 
                                    this.tableInfo=JSON.parse((result.value))  
                                    if( this.tableInfo.length>0)
                                    {
                                       let headers=Object.keys(this.tableInfo[0])
                                            
                                       headers.forEach(element => {                                         
                                            this.tableHead.push({text: element.capitalize(), value:element, class:"tdTotal"})                                
                                       });
                                       
                                      
                                       
                                    }                                   
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        RealoadListSelectValue(id,idOrigin){ 
            let result=this.FormItems.filter(b=> b.BaseIdDocListSelect==id)
            result.forEach(row=>{
                var _result=this.ItemsListSelectValueOrigin[row.ColumnName].filter(b=> b.BaseIdDocListSelectValue==idOrigin)
                
                if(_result.length>0){
                    this.ItemsListSelectValue[row.ColumnName]=_result
                    this.FormItems.filter(b=> b.ColumnName==row.ColumnName)[0].Value=_result[0].IdDocListSelectValue

                }                
                
            })
        },
        exportar(title){ 
                            EventBus.$emit("loading", true)
                            exportExcel.exportToExcel(title,this.tableInfo) 
                            EventBus.$emit("loading", false)
        },
    }
}
</script>
<style>
.columnReadOnly{
    background-color: var(--Fondo2)!important; 
    font-weight: bold;
    color:white!important;
}
</style>
 